import {ReactPhotoGallery} from '@crema/modules/thirdParty';

export default ReactPhotoGallery;
